module.exports = "/_next/static/images/award-monotone-7c7c422ffaa949db691b9d2da41dffd2.svg";